export default __webpack_public_path__ + "assets/hero_1024.1ff56360.webp";